<template>
  <div class="contract-detail-page">
    <div class="detail-card contract-info-card">
      <div class="detail-card-header">
        <div class="breadcrumb-title">
          <span class="breadcrumb-muted breadcrumb-link" @click="goContractQuery">合同查询</span>
          <span class="breadcrumb-arrow">></span>
          <span class="breadcrumb-current">查看合同信息</span>
        </div>
        <el-button size="small" class="figma-btn-back" @click="_goBack">返回</el-button>
      </div>

      <div class="contract-info-box">
        <div class="contract-info-grid">
          <div v-for="item in contractInfoItems" :key="item.label" class="contract-info-item">
            <span class="info-label">{{ item.label }}：</span>
            <span class="info-value">{{ item.value || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-card contract-tabs-card">
      <el-tabs v-model="contractDetailInfo._currentTab" class="figma-detail-tabs" @tab-click="handleTabClick">
        <el-tab-pane v-for="tab in visibleTabs" :key="tab.name" :label="tab.label" :name="tab.name"></el-tab-pane>
      </el-tabs>

      <component
        :is="contractDetailInfo._currentTab"
        :ref="contractDetailInfo._currentTab"
        class="contract-detail-child"
        :contractId="contractDetailInfo.contractId"
        :contractName="contractDetailInfo.contractName"
        :ownerId="contractDetailInfo.objId"
      ></component>
    </div>

    <div class="detail-card action-footer-card">
      <div class="footer-actions">
        <el-button size="small" class="figma-btn-cancel" @click="_goBack">取消</el-button>
        <el-button size="small" type="primary" class="figma-btn-print" @click="_printContract">打印</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ContractDetailRoom from '@/components/contract/contractDetailRoom'
import ContractDetailFile from '@/components/contract/contractDetailFile'
import ContractDetailFee from '@/components/contract/contractDetailFee'
import ContractDetailHisFee from '@/components/contract/contractDetailHisFee'
import OwnerDetailRoomFee from '@/components/owner/ownerDetailRoomFee'
import ContractDetailHisRoomFee from '@/components/contract/contractDetailHisRoomFee'
import ContractDetailChange from '@/components/contract/contractDetailChange'
import ContractDetailFlow from '@/components/contract/contractDetailFlow'
import ContractDetailSub from '@/components/contract/contractDetailSub'
import ContractDetailOwner from '@/components/contract/contractDetailOwner'
import ContractDetailReceipt from '@/components/contract/contractDetailReceipt'
import { queryContract } from '@/api/contract/contractDetailApi'

export default {
  name: 'ContractDetail',
  components: {
    ContractDetailRoom,
    ContractDetailFile,
    ContractDetailFee,
    ContractDetailHisFee,
    OwnerDetailRoomFee,
    ContractDetailHisRoomFee,
    ContractDetailChange,
    ContractDetailFlow,
    ContractDetailSub,
    ContractDetailOwner,
    ContractDetailReceipt
  },
  data() {
    return {
      contractDetailInfo: {
        contractId: '',
        contractName: '',
        contractCode: '',
        contractType: '',
        contractTypeName: '',
        partyA: '',
        partyB: '',
        aContacts: '',
        bContacts: '',
        aLink: '',
        bLink: '',
        operator: '',
        operatorName: '',
        operatorLink: '',
        amount: '',
        contractAmount: '',
        startTime: '',
        endTime: '',
        signingTime: '',
        createTime: '',
        param: '',
        planType: '',
        state: '',
        stateName: '',
        contractParentId: '',
        contractParentName: '',
        contractParentCode: '',
        objId: '',
        files: [],
        _currentTab: 'contractDetailRoom'
      },
      queryTabs: [
        { label: '房屋', name: 'contractDetailRoom' },
        { label: '附件', name: 'contractDetailFile' },
        { label: '业主信息', name: 'contractDetailOwner' },
        { label: '变更记录', name: 'contractDetailChange' },
        { label: '起草审批', name: 'contractDetailFlow' },
        { label: '子合同', name: 'contractDetailSub' },
        { label: '补打收据', name: 'contractDetailReceipt' }
      ],
      allTabs: [
        { label: '房屋', name: 'contractDetailRoom' },
        { label: '附件', name: 'contractDetailFile' },
        { label: '费用', name: 'contractDetailFee' },
        { label: '缴费历史', name: 'contractDetailHisFee' },
        { label: '房屋费用', name: 'ownerDetailRoomFee' },
        { label: '房屋缴费历史', name: 'contractDetailHisRoomFee' },
        { label: '业主信息', name: 'contractDetailOwner' },
        { label: '变更记录', name: 'contractDetailChange' },
        { label: '起草审批', name: 'contractDetailFlow' },
        { label: '子合同', name: 'contractDetailSub' },
        { label: '补打收据', name: 'contractDetailReceipt' }
      ]
    }
  },
  computed: {
    isQueryDetail() {
      return this.$route.path.indexOf('/views/contract/contractQueryDetail') === 0 || this.$route.query.source === 'contractQuery'
    },
    visibleTabs() {
      return this.isQueryDetail ? this.queryTabs : this.allTabs
    },
    contractInfoItems() {
      return [
        { label: '合同名称', value: this.pick('contractName') },
        { label: '合同编号', value: this.pick('contractCode', 'contractNo') },
        { label: '合同类型', value: this.pick('contractTypeName', 'contractType') },
        { label: '甲方', value: this.pick('partyA') },
        { label: '甲方联系人', value: this.pick('aContacts', 'partyAContact') },
        { label: '甲方联系电话', value: this.pick('aLink', 'partyALink') },
        { label: '乙方', value: this.pick('partyB') },
        { label: '乙方联系人', value: this.pick('bContacts', 'partyBContact') },
        { label: '乙方联系电话', value: this.pick('bLink', 'partyBLink') },
        { label: '经办人', value: this.pick('operatorName', 'operator') },
        { label: '联系电话', value: this.pick('operatorLink') },
        { label: '合同金额', value: this.pick('contractAmount', 'amount') },
        { label: '开始时间', value: this.pick('startTime') },
        { label: '结束时间', value: this.pick('endTime') },
        { label: '签订时间', value: this.pick('signingTime', 'createTime') },
        { label: '状态', value: this.formatState(this.pick('stateName', 'state')) }
      ]
    }
  },
  watch: {
    $route() {
      this.initFromRoute()
    }
  },
  created() {
    this.initFromRoute()
  },
  methods: {
    initFromRoute() {
      const contractId = this.$route.params.contractId || this.$route.query.contractId
      this.contractDetailInfo.contractId = contractId || ''
      const currentTab = this.$route.query.currentTab
      if (currentTab) {
        this.contractDetailInfo._currentTab = currentTab
      }
      this.ensureCurrentTab()
      if (this.contractDetailInfo.contractId) {
        this._loadContractInfo()
      }
    },
    pick(...keys) {
      for (const key of keys) {
        const value = this.contractDetailInfo[key]
        if (value !== undefined && value !== null && value !== '') {
          return value
        }
      }
      return ''
    },
    formatState(value) {
      if (value === 0 || value === '0' || value === 'PENDING') return '待审核'
      if (value === 1 || value === '1' || value === 'APPROVED') return '审核通过'
      return value
    },
    ensureCurrentTab() {
      const exists = this.visibleTabs.some(tab => tab.name === this.contractDetailInfo._currentTab)
      if (!exists && this.visibleTabs.length) {
        this.contractDetailInfo._currentTab = this.visibleTabs[0].name
      }
    },
    async _loadContractInfo() {
      try {
        const res = await queryContract({
          page: 1,
          row: 1,
          contractId: this.contractDetailInfo.contractId
        })
        const contract = (res.data || [])[0] || {}
        Object.assign(this.contractDetailInfo, contract)
        this.ensureCurrentTab()
        this.changeTab(this.contractDetailInfo._currentTab)
      } catch (error) {
        console.error('Failed to load contract info:', error)
      }
    },
    handleTabClick(tab) {
      this.changeTab(tab.name || this.contractDetailInfo._currentTab)
    },
    changeTab(tab) {
      this.contractDetailInfo._currentTab = tab
      setTimeout(() => {
        const ref = this.$refs[tab]
        if (ref && ref.open) {
          ref.open({
            contractId: this.contractDetailInfo.contractId,
            contractName: this.contractDetailInfo.contractName,
            ownerId: this.contractDetailInfo.objId
          })
        }
      }, 100)
    },
    goContractQuery() {
      this.$router.push('/pages/committee/contractQuery').catch(() => {})
    },
    _goBack() {
      if (this.isQueryDetail) {
        this.$router.push('/pages/committee/contractQuery').catch(() => {})
        return
      }
      this.$router.go(-1)
    },
    _printContract() {
      const contract = this.contractDetailInfo
      if (!contract.contractId) {
        this.$message.error('缺少合同ID，无法打印')
        return
      }
      window.open(`/#/views/contract/printContract?contractTypeId=${contract.contractType || ''}&contractId=${contract.contractId}`)
    }
  }
}
</script>

<style scoped>
.contract-detail-page {
  min-height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background: #EBF2FA;
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  box-sizing: border-box;
}

.contract-info-card {
  min-height: 314px;
  padding: 20px 24px 28px;
}

.detail-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 38px;
}

.breadcrumb-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.breadcrumb-muted {
  color: #8C9BB4;
}

.breadcrumb-arrow {
  color: #8C9BB4;
  font-weight: 400;
}

.breadcrumb-current {
  color: #1D2129;
}

.figma-btn-back,
.figma-btn-cancel {
  width: 78px;
  height: 38px;
  padding: 0 !important;
  border-radius: 10px !important;
  border-color: #0E76FF !important;
  color: #0E76FF !important;
  background: #fff !important;
  font-size: 14px !important;
}

.contract-info-box {
  margin-top: 30px;
  padding: 22px 24px;
  min-height: 196px;
  box-sizing: border-box;
  background: #F3F7FB;
  border-radius: 8px;
}

.contract-info-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  column-gap: 56px;
  row-gap: 24px;
}

.contract-info-item {
  min-width: 0;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-label {
  color: #8C9BB4;
}

.info-value {
  color: #1D2129;
}

.contract-tabs-card {
  min-height: 318px;
  margin-top: 16px;
  padding: 18px 24px 24px;
}

.figma-detail-tabs >>> .el-tabs__header {
  margin: 0 0 20px;
}

.figma-detail-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
  background: #EBF2FA;
}

.figma-detail-tabs >>> .el-tabs__item {
  height: 32px;
  padding: 0 20px 0 0;
  margin-right: 40px;
  color: #1D2129;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.figma-detail-tabs >>> .el-tabs__item.is-active {
  color: #0E76FF;
}

.figma-detail-tabs >>> .el-tabs__active-bar {
  background: #0E76FF;
}

.contract-detail-child {
  display: block;
}

.action-footer-card {
  height: 94px;
  margin-top: 16px;
  padding: 28px 24px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.figma-btn-print {
  width: 98px;
  height: 38px;
  padding: 0 !important;
  border-radius: 10px !important;
  border-color: #0E76FF !important;
  background: #0E76FF !important;
  font-size: 14px !important;
}

@media (max-width: 1200px) {
  .contract-info-grid {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
}

@media (max-width: 768px) {
  .contract-detail-page {
    padding: 12px;
  }

  .contract-info-card,
  .contract-tabs-card,
  .action-footer-card {
    padding-left: 16px;
    padding-right: 16px;
  }

  .contract-info-grid {
    grid-template-columns: 1fr;
    row-gap: 16px;
  }

  .detail-card-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
}
</style>
